import(/* webpackMode: "eager" */ "/vercel/path0/components/CareerArticle.js")